import React from 'react';

import { useCacheResource } from '../../hooks';
import { ResourceTypes } from '../../utils/services/api';
import useOpen from '../../hooks/useOpen';
import { ProjectEditDrawer } from './ProjectEditDrawer';
import {
  LabelEditLink,
  LabelEditLinkChildrenProps,
} from '../../components/common/buttons';

export const ProjectLabelWithDrawer = (props: {
  resourceId: string;
}): JSX.Element => {
  const { data, loading } = useCacheResource(
    ResourceTypes.PROJECT,
    props.resourceId
  );

  const oi = useOpen(false);

  if (loading) return <span />;

  return (
    <LabelEditLink
      title={data?.name || props.resourceId}
      oi={oi}
      path={'/identity/project/' + props.resourceId}
    >
      {(p: LabelEditLinkChildrenProps) => {
        return (
          <ProjectEditDrawer
            id={props.resourceId}
            open={oi.open}
            onClose={p.onClose}
          />
        );
      }}
    </LabelEditLink>
  );
};
